webpackJsonp([35783957827783],{

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(92)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scrollchor = function (_React$Component) {
	  _inherits(Scrollchor, _React$Component);
	
	  function Scrollchor(props) {
	    _classCallCheck(this, Scrollchor);
	
	    var _this = _possibleConstructorReturn(this, (Scrollchor.__proto__ || Object.getPrototypeOf(Scrollchor)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._setup(props);
	    _this.simulateClick = _this._handleClick;
	    return _this;
	  }
	
	  _createClass(Scrollchor, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this._setup(props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          to = _props.to,
	          animate = _props.animate,
	          beforeAnimate = _props.beforeAnimate,
	          afterAnimate = _props.afterAnimate,
	          disableHistory = _props.disableHistory,
	          props = _objectWithoutProperties(_props, ['to', 'animate', 'beforeAnimate', 'afterAnimate', 'disableHistory']); // eslint-disable-line no-unused-vars
	
	      return !this.props.children ? null : _react2.default.createElement('a', _extends({}, props, { href: '#' + this._to, onClick: this._handleClick }));
	    }
	  }]);
	
	  return Scrollchor;
	}(_react2.default.Component);
	
	// Default easing function
	// jQuery easing 'swing'
	
	
	Scrollchor.propTypes = {
	  to: _propTypes2.default.string.isRequired,
	  animate: _propTypes2.default.shape({
	    offset: _propTypes2.default.number,
	    duration: _propTypes2.default.number,
	    easing: _propTypes2.default.func
	  }),
	  beforeAnimate: _propTypes2.default.func,
	  afterAnimate: _propTypes2.default.func,
	  disableHistory: _propTypes2.default.bool
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setup = function (props) {
	    _this2._to = props.to && props.to.replace(/^#/, '') || '';
	
	    var _ref = props.animate || {},
	        _ref$offset = _ref.offset,
	        offset = _ref$offset === undefined ? 0 : _ref$offset,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 400 : _ref$duration,
	        _ref$easing = _ref.easing,
	        easing = _ref$easing === undefined ? easeOutQuad : _ref$easing;
	
	    _this2._animate = { offset: offset, duration: duration, easing: easing };
	    _this2._beforeAnimate = props.beforeAnimate || function () {};
	    _this2._afterAnimate = props.afterAnimate || function () {};
	    _this2._disableHistory = props.disableHistory;
	  };
	
	  this._handleClick = function (event) {
	    _this2._beforeAnimate(event);
	    event && event.preventDefault();
	    var id = (0, _utils.animateScroll)(_this2._to, _this2._animate);
	
	    if (id) {
	      _this2._disableHistory || (0, _utils.updateHistory)(id);
	      _this2._afterAnimate(event);
	    }
	  };
	};
	
	exports.default = Scrollchor;
	function easeOutQuad(x, t, b, c, d) {
	  return -c * (t /= d) * (t - 2) + b;
	}

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animateScroll = animateScroll;
	exports.updateHistory = updateHistory;
	
	var _warning = __webpack_require__(130);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _requestanimationframeTimer = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function animateScroll(id, animate) {
	  var element = id ? document.getElementById(id) : document.body;
	  (0, _warning2.default)(element, 'Cannot find element: #' + id);
	
	  if (!element) {
	    return null;
	  }
	
	  var offset = animate.offset,
	      duration = animate.duration,
	      easing = animate.easing;
	
	  var start = getScrollTop();
	  var to = getOffsetTop(element) + offset;
	  var change = to - start;
	
	  function animateFn() {
	    var elapsedTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    var increment = 20;
	    var elapsed = elapsedTime + increment;
	    var position = easing(null, elapsed, start, change, duration);
	    setScrollTop(position);
	    elapsed < duration && (0, _requestanimationframeTimer.setTimeout)(function () {
	      animateFn(elapsed);
	    }, increment);
	  }
	
	  animateFn();
	  return id;
	}
	
	function updateHistory(id) {
	  window.location.hash = id;
	}
	
	function getScrollTop() {
	  // like jQuery -> $('html, body').scrollTop
	  return document.documentElement.scrollTop || document.body.scrollTop;
	}
	
	function setScrollTop(position) {
	  document.documentElement.scrollTop = document.body.scrollTop = position;
	}
	
	function getOffsetTop(element) {
	  var _element$getBoundingC = element.getBoundingClientRect(),
	      top = _element$getBoundingC.top;
	
	  return top + getScrollTop();
	}

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(99).default;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _raf = __webpack_require__(93);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var MODE_TIMEOUT = 0;
	var MODE_INTERVAL = 1;
	var fnStacks = new Map();
	var runArray = new Set();
	var rafStarted = false;
	var startId = 0;
	
	function getTimeStamp() {
	  return new Date().getTime();
	}
	
	function executeFn(value) {
	  var fn = value.fn,
	      args = value.args;
	
	  fn.apply(undefined, _toConsumableArray(args));
	}
	
	function runFunction() {
	  if (runArray.size === 0) return;
	  runArray.forEach(executeFn);
	  runArray.clear();
	}
	
	var checkTick = function checkTick(currentTimeTick) {
	  return function (value, id) {
	    var nextTick = value.nextTick,
	        ms = value.ms,
	        mode = value.mode;
	
	    if (currentTimeTick - nextTick >= 0) {
	      runArray.add(value);
	      if (mode === MODE_TIMEOUT) {
	        fnStacks.delete(id);
	      } else {
	        fnStacks.set(id, Object.assign({}, value, {
	          nextTick: nextTick + ms
	        }));
	      }
	    }
	  };
	};
	
	function loop() {
	  var currentTimeTick = getTimeStamp();
	  fnStacks.forEach(checkTick(currentTimeTick));
	  runFunction();
	  if (fnStacks.size === 0) {
	    rafStarted = false;
	    return;
	  }
	  (0, _raf2.default)(loop);
	}
	
	function addId(_ref) {
	  var fn = _ref.fn,
	      _ref$ms = _ref.ms,
	      ms = _ref$ms === undefined ? 0 : _ref$ms,
	      args = _ref.args,
	      mode = _ref.mode;
	
	  if (!fn) return null;
	  var currentId = startId;
	  fnStacks.set(currentId, {
	    fn: fn,
	    ms: ms,
	    nextTick: getTimeStamp() + ms,
	    args: args,
	    mode: mode
	  });
	  if (!rafStarted) {
	    rafStarted = true;
	    (0, _raf2.default)(loop);
	  }
	  startId += 1;
	  return currentId;
	}
	
	function removeId(id) {
	  if (fnStacks.has(id)) {
	    fnStacks.delete(id);
	  }
	  if (fnStacks.size === 0) {
	    rafStarted = false;
	  }
	}
	
	exports.default = {
	  setTimeout: function setTimeout(fn) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return addId({ fn: fn, ms: ms, args: args, mode: MODE_TIMEOUT });
	  },
	  clearTimeout: removeId,
	  setInterval: function setInterval(fn) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	      args[_key2 - 2] = arguments[_key2];
	    }
	
	    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return addId({ fn: fn, ms: ms, args: args, mode: MODE_INTERVAL });
	  },
	  clearInterval: removeId
	};

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/antoine.bea3d4a4.png";

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/electralpes.b4641a9d.jpg";

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo_blanc_full_small = __webpack_require__(59);
	
	var _logo_blanc_full_small2 = _interopRequireDefault(_logo_blanc_full_small);
	
	var _reactScrollchor = __webpack_require__(58);
	
	var _reactScrollchor2 = _interopRequireDefault(_reactScrollchor);
	
	var _reactAnimateOnScroll = __webpack_require__(30);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner(props) {
	    return _react2.default.createElement(
	        'section',
	        { id: 'banner', className: 'major' },
	        _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(
	                _reactAnimateOnScroll2.default,
	                { animateIn: 'stretch' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'major' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'hide' },
	                        'Sites web, conseil, assistance et s\xE9curit\xE9 informatique'
	                    ),
	                    _react2.default.createElement('img', { src: _logo_blanc_full_small2.default, className: 'logo', alt: 'logo societe web2alpes w2a' })
	                )
	            ),
	            _react2.default.createElement(
	                _reactAnimateOnScroll2.default,
	                { animateIn: 'fadeInUp' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Services, conseil et s\xE9curit\xE9 informatique'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Pour les professionnels au c\u0153ur des Alpes'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'actions' },
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _reactScrollchor2.default,
	                                { to: '#services', title: 'En savoir plus sur les services propos\xE9s', className: 'button next scrolly' },
	                                'En savoir plus'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactAnimateOnScroll = __webpack_require__(30);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _Banner = __webpack_require__(174);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _reactScrollchor = __webpack_require__(58);
	
	var _reactScrollchor2 = _interopRequireDefault(_reactScrollchor);
	
	var _antoine = __webpack_require__(450);
	
	var _antoine2 = _interopRequireDefault(_antoine);
	
	var _electralpes = __webpack_require__(451);
	
	var _electralpes2 = _interopRequireDefault(_electralpes);
	
	var _logo_blanc_full_small = __webpack_require__(59);
	
	var _logo_blanc_full_small2 = _interopRequireDefault(_logo_blanc_full_small);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import Slider from 'react-slick';
	
	//import MapStreet from '../components/MapStreet'
	//<MapStreet className="leaflet-container" />
	//import StreetMap from '../components/StreetMap' 
	//import MapStreet from '../components/PigeonMap';
	// <section><MapStreet /></section>
	
	
	//import pic01 from '../assets/images/web_programming.jpg'
	//import pic02 from '../assets/images/concentric.jpg'
	//import pic03 from '../assets/images/applis.jpg'
	//import pic04 from '../assets/images/conseil.jpg'
	//import pic05 from '../assets/images/conseil.jpg'
	//import pic06 from '../assets/images/call-center.jpg'
	
	
	//import reponsive from '../assets/images/responsive.svg';
	
	//style={{background: `linear-gradient(rgba(255,255,255,.5), rgba(255,255,255,.5)),cover, url(${pic01})`}}
	//<Banner />
	
	var sliderSettings = {
	    //dots: true,
	    infinite: true,
	    speed: 500,
	    centerMode: true,
	    adaptiveHeight: true,
	    slidesToShow: 2,
	    slidesToScroll: 1,
	    rows: 3
	};
	
	var HomeIndex = function (_React$Component) {
	    _inherits(HomeIndex, _React$Component);
	
	    function HomeIndex() {
	        _classCallCheck(this, HomeIndex);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    HomeIndex.prototype.render = function render() {
	        var siteUrl = this.props.data.site.siteMetadata.siteUrl;
	        var siteTitle = this.props.data.site.siteMetadata.title;
	        var siteDescription = this.props.data.site.siteMetadata.description;
	        var siteKeyWords = this.props.data.site.siteMetadata.keywords;
	        /*
	                            <section id="clients">
	                                <div className="inner">
	                                    <header>
	                                        <h2><span className="icon alt fa-user"></span> Clients</h2>
	                                     </header>
	                                    <Slider {...sliderSettings}>
	                                        <div><img src={electralpes}></img></div>
	                                        <div><img src={electralpes}></img></div>
	                                        <div><img src={electralpes}></img></div>
	                                    </Slider>
	                                </div>
	                            </section>
	        
	        */
	        return _react2.default.createElement(
	            'div',
	            { style: this.props.transition && this.props.transition.style },
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    siteTitle
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: siteDescription }),
	                _react2.default.createElement('meta', { name: 'keywords', content: siteKeyWords }),
	                _react2.default.createElement('meta', { name: 'language', content: 'fr-FR' }),
	                _react2.default.createElement('meta', { 'http-equiv': 'content-type', content: 'text/html; charset=UTF-8' }),
	                _react2.default.createElement('meta', { 'http-equiv': 'content-language', content: 'fr-FR' }),
	                _react2.default.createElement('meta', { property: 'og:title', content: siteTitle }),
	                _react2.default.createElement('meta', { property: 'og:locale', content: 'fr_FR' }),
	                _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	                _react2.default.createElement('meta', { property: 'og:site_name', content: siteTitle }),
	                _react2.default.createElement('meta', { property: 'og:description', content: siteDescription }),
	                _react2.default.createElement('meta', { property: 'og:url', content: siteUrl }),
	                _react2.default.createElement('meta', { property: 'og:image', content: _logo_blanc_full_small2.default }),
	                _react2.default.createElement('meta', { name: 'twitter:card', content: '' }),
	                _react2.default.createElement('meta', { name: 'twitter:site', content: siteUrl }),
	                _react2.default.createElement('meta', { name: 'twitter:title', content: siteTitle }),
	                _react2.default.createElement('meta', { name: 'twitter:image', content: _logo_blanc_full_small2.default }),
	                _react2.default.createElement('meta', { name: 'twitter:description', content: siteDescription }),
	                _react2.default.createElement('link', { rel: 'canonical', href: siteUrl })
	            ),
	            _react2.default.createElement(_Banner2.default, null),
	            _react2.default.createElement(
	                'div',
	                { id: 'main' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'services', className: 'tiles' },
	                    _react2.default.createElement(
	                        'article',
	                        null,
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _react2.default.createElement('i', { className: 'icon fa-gear' }),
	                                'Infrastructure'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Suivi global, conseil ou assistance ponctuelle de votre syst\xE8me d\u2019information : syst\xE8mes, r\xE9seaux et s\xE9curit\xE9'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/infrastructure-informatique/', title: 'Int\xE9gration et audit syst\xE8mes d\'informations', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        null,
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _react2.default.createElement('i', { className: 'icon fa-support' }),
	                                'Assistance'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Accompagnement ou conseil dans le choix, la mise en place et la mise \xE0 jour de vos solutions mat\xE9rielles et logicielles'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/assistance-informatique/', title: 'Conseil et assistance informatique', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        null,
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _react2.default.createElement('i', { className: 'icon fa-shield' }),
	                                'Suivi securite'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Expertise, conseil et mises \xE0 jour de s\xE9curit\xE9 de sites web, applications, postes de travail, serveurs, pare-feu et r\xE9seaux informatique...'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/configuration-et-suivi-securite-informatique/', title: 'Suivi s\xE9curit\xE9 mensuel', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        null,
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _react2.default.createElement('i', { className: 'alticon-responsive' }),
	                                'Sites & Applis'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Cr\xE9ation, gestion et r\xE9f\xE9rencement de votre site web vitrine ou e-boutique & d\xE9veloppement d\u2019applications sur mesure'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/creation-sites-internet-et-applications/', title: 'creation et r\xE9f\xE9rencement de sites web et d\'applications', className: 'link primary' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { id: 'about', className: 'spotlights' },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        { animateIn: 'fadeIn', 'data-content': 'MON CV', className: 'image center' },
	                        _react2.default.createElement('img', { className: 'logo', src: _antoine2.default, alt: 'Photo Antoine' }),
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/cv/', title: 'Mon curriculum vitae' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'button' },
	                                'MON CV ',
	                                _react2.default.createElement('i', { className: 'icon fa-graduation-cap' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner-center-medium' },
	                            _react2.default.createElement(
	                                'header',
	                                null,
	                                _react2.default.createElement(
	                                    _gatsbyLink2.default,
	                                    { to: '/cv/', title: 'Mon curriculum vitae' },
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _react2.default.createElement('span', { className: 'icon alt fa-user' }),
	                                        '  Antoine'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'center-medium' },
	                                'Ing\xE9nieur informatique de formation, je travaille depuis huit ans dans la s\xE9curit\xE9 et les r\xE9seaux informatiques pour la M\xE9tropole de Grenoble. Passionn\xE9 d\'informatique, j\'ai pu apprendre dans des domaines vari\xE9s : conseil, maintenance, assistance et expertise informatique syst\xE8mes, r\xE9seaux et s\xE9curit\xE9, d\xE9veloppement d\'applications et de sites web et enfin gestion de projet. Addict de la montagne depuis de nombreuses ann\xE9es, j\'ai d\xE9cid\xE9 de m\'installer et de lancer mon activit\xE9 aux Deux Alpes en 2018.'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return HomeIndex;
	}(_react2.default.Component);
	
	exports.default = HomeIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-c2f655115ea34df365ca.js